import React from 'react';
import { motion } from 'framer-motion';
import SampleImage from '../../assets/images/architecture-2287327_1280.jpg';

const Xyz = () => {
  return (
    <section className="w-full bg-gradient-to-b from-[#f4f9fc] to-[#e8f4fc] py-20 px-4 4xl:px-32">
      <div className="max-w-7xl 4xl:max-w-[1700px] mx-auto flex flex-col md:flex-row items-center gap-12 4xl:gap-24">

        {/* Animated Image Section */}
        <motion.div
          className="w-full md:w-1/2 4xl:w-[55%] relative"
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-[#5bc0fe20]">
            <img
              src={SampleImage}
              alt="Why Choose LABH Industries"
              className="object-cover w-full max-h-[500px] 4xl:max-h-[650px]"
              loading="lazy"
            />
          </div>
        </motion.div>

        {/* Animated Text Content */}
        <motion.div
          className="w-full md:w-1/2 4xl:w-[45%] text-center md:text-left"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl 4xl:text-5xl font-extrabold text-[#00b3ff] mb-6 leading-tight">
            Why Choose <span className="text-gray-800">LABH Industries?</span>
          </h2>
          <p className="text-gray-700 text-lg 4xl:text-xl leading-relaxed">
            With a legacy of engineering excellence and a passion for building high-quality EPC projects,
            we are committed to providing solutions that combine innovation, efficiency, and reliability.
          </p>
          <p className="mt-4 text-gray-600 text-md 4xl:text-lg italic">
            Partner with us to bring your vision to life — engineered to perfection.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Xyz;
